import http from './httpRequest.js'

/**
 * 获取全局版本号
 */
export function getGlobalVersion() {
	return http({
		url: '/chat/global/getVersion',
		method: 'get'
	})
}
